import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// App Check: use debug token in development (token registered in Firebase Console).
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// Only load console monitor in development
if (process.env.NODE_ENV === 'development') {
  import("./console-monitor-http.js");
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
